import BaseStore from "@/stateManagement/BaseStore";
import { StoreConfig } from "@datorama/akita";
import { singleton } from "tsyringe";

export interface CustomerState {
    storeCreditBalance: string | null;
}

const createInitialState = (): CustomerState => ({
    storeCreditBalance: null,
});

@singleton()
@StoreConfig({ name: "CustomerStore" })
class CustomerStore extends BaseStore<CustomerState> {
    constructor() {
        super(createInitialState());
    }
}

export default CustomerStore;
